// /v1/instituicoes-financeiras/{guidInstituicao}/enderecosimport { AxiosResponse } from 'axios'
import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import { AddressSchemaForm } from 'pages/Institution/components/Address/interfaces'
import api from './api'

const { ENDPOINT_API_INSTITUTIONS } = environments

interface PayloadEditAddress {
    idInstitution: string
    data: AddressSchemaForm
    idAddress: string
}

export const createAddress = async (
    idInstitution: string,
    data: AddressSchemaForm
): Promise<AxiosResponse<any>> => {
    return api.post(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/enderecos`,
        data
    )
}

export const editAddress = async ({
    idInstitution,
    data,
    idAddress
}: PayloadEditAddress): Promise<AxiosResponse<any>> => {
    return api.put(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/enderecos/${idAddress}`,
        data
    )
}

export const deleteAddress = async (
    idInstitution: string,
    idAddress: string
): Promise<AxiosResponse<void>> => {
    return await api.delete(
        `${ENDPOINT_API_INSTITUTIONS}/instituicoes-financeiras/${idInstitution}/enderecos/${idAddress}`
    )
}
